(function() {
    'use strict';
    angular
        .module('MW.ContactManager.ContactManagerInfluencerDatabaseUpsellController', [])
        .controller('ContactManagerInfluencerDatabaseUpsellController', [
            '$translate',
            '$location',
            'isInfluencerAppEntitled',
            ContactManagerInfluencerDatabaseUpsellController
        ]);

    function ContactManagerInfluencerDatabaseUpsellController($translate, $location, isInfluencerAppEntitled) {
        this.$translate = $translate;
        this.$location = $location;

        this.pageTitle = this.$translate.instant('icm-web__upsell-page--title');
        this.pageDescription = this.$translate.instant('icm-web__upsell-page--description');
        this.pageFooter = this.$translate.instant('icm-web__upsell-page--footer').replace(/&gt;/g, '>').replace(/&lt;/g, '<');

        if (isInfluencerAppEntitled === true) {
            this.$location.url('/influencers/lists');
        }
    }

}());